<template>
    <div class="info-component-wrapper mt-3">
        <!-- <div class="pb-2 m-4 d-flex" style="border-bottom: 1px solid #242424;position:relative">
            <h6 class="m-0 text-left pl-4">System Info</h6>
        </div> -->
        <ul>
                <li>
                    <div class="key-style">URL</div>
                    <div class="value-style">
                        <a  href="" v-on:click="openUrl()">{{windowLocationUrl}}</a>
                        </div>
                </li>
                <li v-if="Object.keys(systemInfo).includes('app_id') &&
                !['undefined',null].includes(systemInfo.app_id) &&  systemInfo.app_id.length > 0">
                    <div class="key-style">APP-ID</div>
                    <div class="value-style">{{systemInfo.app_id}}</div>
                </li>
                <li v-if="Object.keys(systemInfo).includes('version_id') &&
                !['undefined',null].includes(systemInfo.version_id) &&  systemInfo.version_id.length > 0">
                    <div class="key-style">Version</div>
                    <div class="value-style">{{systemInfo.version_id}}</div>
                </li>
                <li v-if="Object.keys(systemInfo).includes('os') &&
                !['undefined',null].includes(systemInfo.os) &&  systemInfo.os.length > 0">
                    <div class="key-style">OS</div>
                    <div class="value-style">{{systemInfo.os}}</div>
                </li>
                <li v-if="Object.keys(systemInfo).includes('memory') &&
                !['undefined',null].includes(systemInfo.memory) &&  systemInfo.memory.length > 0">
                    <div class="key-style">Memory</div>
                    <div class="value-style">{{systemInfo.memory}}</div>
                </li>
                <li v-if="Object.keys(systemInfo).includes('deployment_type') &&
                !['undefined',null].includes(systemInfo.deployment_type) &&  systemInfo.deployment_type.length > 0">
                    <div class="key-style">Deployment Type</div>
                    <div class="value-style">{{systemInfo.deployment_type}}</div>
                </li>
                <li v-if="Object.keys(systemInfo).includes('system_time') &&
                !['undefined',null].includes(systemInfo.system_time) &&  systemInfo.system_time.length > 0">
                    <div class="key-style">System Time</div>
                    <div class="value-style">{{moment.utc().format(systemInfo.system_time)}}</div>
                </li>
                <li v-if="Object.keys(systemInfo).includes('timezone') &&
                !['undefined',null].includes(systemInfo.timezone) &&  systemInfo.timezone.length > 0">
                    <div class="key-style">Timezone</div>
                    <div class="value-style">{{systemInfo.timezone}}</div>
                </li>
                <li v-if="Object.keys(systemInfo).includes('system_uptime') &&
                !['undefined',null].includes(systemInfo.system_uptime) &&  systemInfo.system_uptime.length > 0">
                    <div class="key-style">System Uptime</div>
                    <div class="value-style">{{systemInfo.system_uptime}}</div>
                </li>
                <li v-if="Object.keys(systemInfo).includes('assets_count') &&
                !['undefined',null].includes(systemInfo.assets_count)">
                    <div class="key-style">Asset count</div>
                    <div class="value-style">{{systemInfo.assets_count}}</div>
                </li>
                <li v-if="Object.keys(systemInfo).includes('jobs_count') &&
                !['undefined',null].includes(systemInfo.jobs_count)">
                    <div class="key-style">Job count</div>
                    <div class="value-style">{{systemInfo.jobs_count}}</div>
                </li>
                <li v-if="Object.keys(systemInfo).includes('audit_trail_count') &&
                !['undefined',null].includes(systemInfo.audit_trail_count)">
                    <div class="key-style">Audit trail count</div>
                    <div class="value-style">{{systemInfo.audit_trail_count}}</div>
                </li>
                <li v-if="Object.keys(systemInfo).includes('db_backup_service_status') &&
                !['undefined',null].includes(systemInfo.db_backup_service_status) &&  systemInfo.db_backup_service_status.length > 0">
                    <div class="key-style">DB backup service status</div>
                    <div class="value-style" :class="systemInfo.db_backup_service_status == 'Disabled'?'text-danger':'text-success'">{{systemInfo.db_backup_service_status}}</div>
                </li>
                <li v-if="Object.keys(systemInfo).includes('job_cleanup_service_status') &&
                !['undefined',null].includes(systemInfo.job_cleanup_service_status) &&  systemInfo.job_cleanup_service_status.length > 0">
                    <div class="key-style">Job cleanup service Status</div>
                    <div class="value-style" :class="systemInfo.job_cleanup_service_status == 'Disabled'?'text-danger':'text-success'">{{systemInfo.job_cleanup_service_status}}</div>
                </li>
                <li v-if="Object.keys(systemInfo).includes('audit_trail_cleanup_service_status') &&
                !['undefined',null].includes(systemInfo.audit_trail_cleanup_service_status) &&  systemInfo.audit_trail_cleanup_service_status.length > 0">
                    <div class="key-style">Audit trail cleanup service Status</div>
                    <div class="value-style" :class="systemInfo.audit_trail_cleanup_service_status == 'Disabled'?'text-danger':'text-success'">{{systemInfo.audit_trail_cleanup_service_status}}</div>
                </li>
                <li v-if="Object.keys(systemInfo).includes('licence_type') &&
                !['undefined',null].includes(systemInfo.licence_type) &&  systemInfo.licence_type.length > 0">
                    <div class="key-style">Licence Type</div>
                    <div class="value-style">{{systemInfo.licence_type}}</div>
                </li>
                <li v-if="Object.keys(systemInfo).includes('installed_plugins') &&
                !['undefined',null].includes(systemInfo.installed_plugins) &&  systemInfo.installed_plugins.length > 0">
                    <div class="key-style">Installed plugins</div>
                    <div class="value-style">{{formattedInstalledPluginsList(systemInfo.installed_plugins)}}
                    </div>
                </li>
        </ul>
    </div>
</template>


<script>
import { mapActions } from 'vuex'
import Constants from "../../components.constants.js"

export default{
    data(){
        return{
            systemInfo:[],
            windowLocationUrl:this.formattedUrl(Constants.windowLocationHref)
        }
    },
    methods:{
        openUrl(){
            window.open(this.windowLocationUrl);
        },
        formattedInstalledPluginsList(list){
            let temp = list.toString().replace("/[]/g","");
            let temp2 = temp.toString().split(",").join(", ");
            return temp2;
        },
        formattedUrl(url){
            var the_arr = url.split('/');
            the_arr.pop();
            return( the_arr.join('/') );
        },
        ...mapActions("settings",["getSystemInfoFromServer"])
    },
    created(){
        this.getSystemInfoFromServer().then((data) => {
            this.systemInfo = data.system_info;
        })
    }
}

</script>


<style lang="scss" scoped>
$border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;

ul{
    list-style-type: none;
    padding: 0px;
    margin-inline-start:10px;
    li{
        display:inline-flex;
        width: 100%;
        padding:7px;
        .key-style{
            color:$dull-text-color;
            width:22%;
            text-align: end;
        }
        .value-style{
            color: $text-color;
            width: 70%;
            text-align: start;
            margin-inline-start: 11px;
        }
    }
}
.info-component-wrapper{
    height:92%;
    overflow:auto;
}

.no-data-found{
    font-size: 20px; 
    margin-top: 8%; 
    color: $dull-text-color;
    text-align:center
}

.text-as-list-styles{
    display:inline-flex;
}

/* width */
::-webkit-scrollbar {
    width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
}

</style>